/*
Test URL: http://localhost:8080/flyer/D0336?storeId=148&language=en&_fc=ctc&userId=e43558fb56b5442d9abb2d5e6673885d&ufname=user%20test&products=0436962,0370566,0576011


"api": {
		"url": "https://ctcpersonalizationapi-s.azurewebsites.net",
		"endpoints": {
		  "auth": {
			"path": "/api/CTC/requesttoken",
			"post": {
			  "response": {
			  	transform: {
			  		"access_token": "access_token",
			  		"expires_in": "expires_in",
			  		"token_type": "token_type",
			  		"refresh_token": "refresh_token",
			  		"scope": "scope",
			  		"id_token": "id_token"
			  	}
			  }
		  },
		  "products": {
			  "path": "/api/Wishlist/products"
		  }
		}
	  }
 */

import AppConfig from "@/classes/AppConfig";
import PersistentData from "@/classes/PersistentData";

const tokenCache = new PersistentData('WishListApi');

//TODO: Add Data transforms for API responses

export default class WishListApi {
	#config;
	#authEndpoint;
	#productsEndpoint;
	#apiKey;

	constructor(config) {
		const url = AppConfig?.AppConf?.offers_api?.url || config?.url;
		this.#config = config;

		this.#apiKey = AppConfig?.AppConf?.offers_api?.key;
		
		this.#authEndpoint = `${url}${config?.endpoints?.auth?.path}`;
		this.#productsEndpoint = `${url}${config?.endpoints?.products?.path}`;
		console.log('authEndpoint', `${url}${config?.endpoints?.auth?.path}`);
		if (!url) throw new Error('WishListApi: No API URL configured');
		if (!this.#config?.endpoints?.auth?.path) throw new Error('WishListApi: No Auth Endpoint configured');
		if (!this.#config?.endpoints?.products?.path) throw new Error('WishListApi: No Products Endpoint configured');
		if (!this.#apiKey) throw new Error('WishListApi: No API Key configured');
	}

	get tokenKey() {
		return `${this.#authEndpoint}/token`;
	}

	get token() {
		const cached = tokenCache.getData(this.tokenKey);
		return cached?.access_token || cached?.accessToken;
	}

	setTokenObj(token) {
		if(!token) {
			tokenCache.removeData(this.tokenKey);
			return;
		}
		const expiresIn = token?.expires_in ?? token?.expiresIn;
		tokenCache.setData(this.tokenKey, token, expiresIn * 1000);
	}


	async getBearerToken(getNew = false) {
		if (this.token && !getNew) return this.token;
		try {
			const response = await fetch(this.#authEndpoint, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'ApiKey': this.#apiKey
				}
			})
			const token = await response.json();
			this.setTokenObj(token);
		} catch (e) {
			console.log('WishListApi: Auth Error:', e);
			this.setTokenObj(null);
		}
		return this.token;
	}

	async getProducts(userId, storeId, language, productCodes = []) {
		const token = await this.getBearerToken();
		if (!token) return [];
		try {
			const response = await fetch(this.#productsEndpoint, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${token}`,
					'ApiKey': this.#apiKey
				},
				body: JSON.stringify({
					userId,
					storeId: String(storeId),
					language,
					productCodes
				})
			})
			const { data } = await response.json();
			return data?.products || [];
		}catch(e) {
			console.log('WishListApi: Products Error:', e);
			return [];
		}
	}
}
